const Empty = ({ children }) => children;

export default Empty;
